import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["submitButton"]
    static values = {
        firstNameField: String,
        lastNameField: String,
        educationalLevelField: String,
        visibleToInstitutionsField: String
    }

    connect() {
        this.firstNameInput = this.element.querySelector(`input[name="${this.firstNameFieldValue}"]`)
        this.lastNameInput = this.element.querySelector(`input[name="${this.lastNameFieldValue}"]`)
        this.educationalLevelInputs = this.element.querySelectorAll(`input[name="${this.educationalLevelFieldValue}"]`)
        this.visibleToInstitutionsInputs = this.element.querySelectorAll(`input[name="${this.visibleToInstitutionsFieldValue}"]`)
        this.setupEventListeners()
        this.validateForm()
    }

    setupEventListeners() {
        [this.firstNameInput, this.lastNameInput].forEach(input => {
            if (!input) return
            input.addEventListener('input', () => {
                input.value = input.value.replace(/[^a-zA-Z\s'-]/g, '')
                this.validateForm()
            })
        })
        
        Array.from(this.educationalLevelInputs).concat(Array.from(this.visibleToInstitutionsInputs)).forEach(input => {
            input.addEventListener('change', () => this.validateForm())
        })
    }

    validateForm() {
        const firstName = this.firstNameInput?.value.trim()
        const lastName = this.lastNameInput?.value.trim()
        const educationalLevel = this.element.querySelector(`input[name="${this.educationalLevelFieldValue}"]:checked`)
        const visibleToInstitutions = this.element.querySelector(`input[name="${this.visibleToInstitutionsFieldValue}"]:checked`)
        
        const isFormValid = firstName && lastName && educationalLevel && visibleToInstitutions

        if (!this.hasSubmitButtonTarget) return

        const button = this.submitButtonTarget
        button.disabled = !isFormValid
        
        if (isFormValid) {
            button.classList.remove('bg-[#717A8B]')
            button.classList.add('bg-[#002F87]')
        } else {
            button.classList.remove('bg-[#002F87]')
            button.classList.add('bg-[#717A8B]')
        }
    }
}
